import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, interval, of } from 'rxjs';
import { map, switchMap, takeWhile } from 'rxjs/operators';
import { ShoppingCartService } from './shopping-cart.service';

@Injectable({
    providedIn: 'root'
})
export class ShoppingCartIconService {
    private shoppingCartCount = new BehaviorSubject<number>(null);
    public shoppingCartCountValue = this.shoppingCartCount.asObservable();
    timer$: Observable<string>;
    private timerTrigger$ = new Subject<Date | null>();

    constructor(private shoppingCartService: ShoppingCartService) {
        this.timer$ = this.timerTrigger$.pipe(
            switchMap((deletionTimestamp) => {
                if (!deletionTimestamp) {
                    return of(null);
                }
                const endTime = deletionTimestamp.getTime();
                return interval(1000).pipe(
                    map(() => {
                        const currentTime = Date.now();
                        const timeLeft = endTime - currentTime;
                        if (timeLeft === 0) {
                            this.shoppingCartService.setCartId(null);
                        }
                        if (timeLeft < 0) {
                            return null;
                        }
                        const minutes = Math.floor(timeLeft / 60000);
                        const seconds = Math.floor((timeLeft % 60000) / 1000);
                        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                    }),
                    takeWhile((time) => time !== null, true)
                );
            })
        );
    }

    initializeHeaderShoppingCart(count: number, deletionTimestamp: Date) {
        this.shoppingCartCount.next(count);
        this.timerTrigger$.next(new Date(deletionTimestamp));
    }
}
